<div *ngIf="showHeader">
  <header class="header">
    <div class="container header-inner">
      <button type="button" class="logo-button" (click)="goHomeFromLogo()">
        <img src="assets/walgreenslogo.png" alt="Walgreens" class="logo" />
      </button>

      <!-- LOGIN (ONLY /) -->
      <button class="button-primary" *ngIf="!isLoggedIn" (click)="login()">
        Login
      </button>

      <!-- COMPANY NAME + MENU (ONLY /home) -->
      <div class="header-actions" *ngIf="isLoggedIn">
        <span class="company-name">{{companyName}}</span>
        <button class="menu-button" (click)="toggleSidebar()"><i class="fa fa-bars menu-icon" aria-hidden="true"></i>
          Menu</button>
      </div>
    </div>
  </header>

  <!-- OVERLAY -->
  <div class="sidebar-overlay" *ngIf="isLoggedIn" [class.show]="isSidebarOpen" (click)="closeSidebar()">
  </div>

  <!-- SIDEBAR -->
  <aside class="sidebar" *ngIf="isLoggedIn" [class.open]="isSidebarOpen">

    <div class="sidebar-header">
      <span class="company-name">{{companyName}}</span>
      <button class="close-btn" (click)="closeSidebar()">X</button>
    </div>
    <nav class="sidebar-menu" *ngFor="let item of menuList">
      <a *ngIf="item.name !== 'Logout'" class="nav-link" [routerLink]="[item.route]" routerLinkActive="active-link">
        {{ item.name }}
      </a>

      <a *ngIf="item.name === 'Logout'" class="nav-link" href="javascript:void(0)" (click)="openLogoutConfirm()">
        {{ item.name }}
      </a>
    </nav>
  </aside>
  <p-dialog header="Confirm Logout" [(visible)]="showLogoutConfirm" [closable]="false" [closeOnEscape]="false"
    [modal]="true" [dismissableMask]="false" [style]="{ width: '40vw' }" [breakpoints]="{ '640px': '95vw' }">

    <div class="dialog-body">
      Do you want to logout?
    </div>

    <ng-template pTemplate="footer">
      <div class="actions">
        <button type="button" class="button-secondary" (click)="confirmLogout()">Yes</button>
        <button type="button" class="button-primary" (click)="cancelLogout()">No</button>
      </div>
    </ng-template>
  </p-dialog>
</div>